import React from 'react';

function formatDate(gameId) {

    const parts = gameId.split('_');
    const date = parts[0];
    const game = parts[1];

    const year = date.substring(2, 4);
    const month = date.substring(4, 6);
    const day = date.substring(6, 8);

    const formattedDate = `${month}/${day}/${year}`;

    return `${formattedDate}`;
}


const Game = ({ game, onClick }) => {
    const date = formatDate(game.gameID);

    let statusText;
    switch (game.gameStatus) {
        case 'In Progress':
            statusText = 'In Progress';
            break;
        case 'Completed':
            statusText = 'End';
            break;
        case 'Not Yet Started':
        default:
            statusText = ''; // Display nothing
            break;
    }

    return (
        <div className="game" onClick={() => onClick(game)}>
            <div className="time">{game.gameTime} (ET)</div>
            <div className="team">
                <span>{game.away}</span>
                <span>{game.awayPts}</span>
            </div>
            <div className="team">
                <span>{game.home}</span>
                <span>{game.homePts}</span>
            </div>
            {/*statusText && <span className="gameStatus">{statusText}</span>*/}
            {game.gameClock}
        </div>
    );
};

export default Game;
